var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "M457 121 336 0H86C69 0 55 14 55 30v452c0 8 4 16 9 21 6 6 13 9 22 9h340c9 0 16-3 22-9l-5-4 5 4c5-5 9-13 9-21z",
    opacity: 1,
    "data-original": "#dfdfdf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b5b5b5",
    d: "m340 2 115 115c4 3 1 10-4 10h-91c-17 0-30-14-30-30V6c0-5 6-8 10-4z",
    opacity: 1,
    "data-original": "#b5b5b5",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c5a82",
    d: "M55 240v172h317c9 0 16-3 22-9l-5-4 5 4c5-5 8-13 8-21V270c0-9-3-16-8-22l-5 5 5-5c-6-5-13-8-22-8z",
    opacity: 1,
    "data-original": "#3c5a82",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#b5b5b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 201c-8 0-8 12 0 12h258c8 0 8-12 0-12zM100 155c-8 0-8 12 0 12h258c8 0 8-12 0-12z",
    fill: "#b5b5b5",
    opacity: 1,
    "data-original": "#b5b5b5",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M122 372v-93h13v93zm34 0v-93h19c7 24 19 57 26 80 7-24 19-56 27-80h17v93h-12v-78l-27 78h-11l-27-79v79zm152-36v-11h39v34c-35 29-86 15-86-33 0-55 61-57 78-36 3 4 5 9 7 15l-11 3c-4-13-12-20-27-20-37 0-38 41-30 58 11 22 43 20 57 7v-17z",
    opacity: 1,
    "data-original": "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.56cd9c8694263e807ae9cf7d0d06fe99.svg";
export { ForwardRef as ReactComponent };